'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('ldap-db', {
      url: '/admin/ldap-db',
      template: '<ldap-db></ldap-db>',
      authenticate: 'suite-superadmin'
    });
}



// WEBPACK FOOTER //
// ./client/app/admin/ldap-db/ldap-db.routes.js